<template>
  <div>工作台</div>
</template>

<script>
export default {
  name: 'workbench',
  data () {
    return {
      shrink: false
    }
  },
  methods: {
  }
}
</script>
